export const SubmissionStatus = {
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    PendingReview: 'Pending Manual Review'
};
